import { render } from "./DailyWord.vue?vue&type=template&id=1a80500a&scoped=true"
import script from "./DailyWord.vue?vue&type=script&lang=js"
export * from "./DailyWord.vue?vue&type=script&lang=js"

import "./DailyWord.vue?vue&type=style&index=0&id=1a80500a&scoped=true&lang=css"

import exportComponent from "D:\\Dev\\devine-mot\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a80500a"]])

export default __exports__